// extracted by mini-css-extract-plugin
module.exports = {"container":"jUCl0fASoNgOxBbQwdwfK primaryBackgroundColor","inner":"_3hjuKvUPNAui61ND4n_DuE"};